import { render, staticRenderFns } from "./AnalyticsCard.vue?vue&type=template&id=12c97103&scoped=true&"
import script from "./AnalyticsCard.vue?vue&type=script&lang=ts&"
export * from "./AnalyticsCard.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyticsCard.vue?vue&type=style&index=0&id=12c97103&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c97103",
  null
  
)

export default component.exports